import { NOT_SAVED_ID } from "app/model"
import { IForm, IFormOperatorRow } from "form/model"
import { IOperator } from "operator/model"
import { ISsp } from "ssp/model"
import { getAllSspsInStore } from "ssp/tools/common"

// This file exist because Umbracity is an exception
// Umbracity is an operator that is itself an ssp
// API returns umbracity as an ssp, so in the UI
// if ssp umbracity is selected, we need to add
// an umbracity operator that is always checked

export function isUmbracitySsp(ssp: ISsp): boolean {
  const lowerCaseUmbracityName = getUmbracityName().toLowerCase()
  return ssp.name.toLowerCase() === lowerCaseUmbracityName || ssp.id === UMBRACITY_SSP_ID
}

export function getUmbracityRow(sspId: number): IFormOperatorRow {
  return {
    id: getUmbracityStringId(),
    cpm: 0,
    sspId,
    impression: 0,
    impressionDiff: 0,
    impressionPercent: 0,
    impressionRatio: "-",
    publisherId: getUmbracityId(),
    publisherName: getUmbracityName(),
    screens: 0,
    screensDiff: 0,
    screensPercent: 0,
    screensRatio: "-"
  }
}

export function getSummaryOperatorsWithUmbracityIfNeeded(form: IForm): IOperator[] {
  const umbracitySsp = getUmbracitySspIfSelected(form)
  if (!umbracitySsp) {
    return form.screens.operators
  }
  return [
    ...form.screens.operators,
    {
      id: NOT_SAVED_ID,
      publisher_id: getUmbracityId(),
      ssp_id: umbracitySsp.id,
      is_deleted: false,
      default_deal_id: null,
      publisher_name: getUmbracityName(),
      publisher_url: ""
    }
  ]
}

// id and name at the same time
export const getUmbracityId = (): number => -10

export const getUmbracityStringId = (): string => `${UMBRACITY_SSP_ID}-${getUmbracityId()}`

export const getUmbracityName = (): string => "Umbracity"

const getUmbracitySspIfSelected = (form: IForm): ISsp | null => {
  const lowerCaseUmbracityName = getUmbracityName().toLowerCase()
  const umbracitySsp = getAllSspsInStore().find(
    ssp => ssp.name.toLowerCase() === lowerCaseUmbracityName || ssp.id === UMBRACITY_SSP_ID
  )
  if (!umbracitySsp) {
    return null
  }
  return form.screens.sspIds.includes(umbracitySsp.id) ? umbracitySsp : null
}
